import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import PatientPortalMedicalHistory from '../components/PatientPortalMedicalHistory';
import { usePatientPortal } from '../context/PatientPortalContext';

const { Title, Text } = Typography;

const PatientPortalMedicalHistoryPage = () => {
  const { patient } = usePatientPortal();

  return (
    <div style={{ padding: '24px', background: '#f5f5f5', minHeight: '100vh' }}>
      {/* Page Header */}
      <div style={{ marginBottom: '24px' }}>
        <Row align="middle" gutter={16}>
          <Col>
            <HistoryOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
          </Col>
          <Col>
            <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
              📋 Medical History
            </Title>
            <Text type="secondary" style={{ fontSize: '16px' }}>
              Your complete medical history, surgeries, and health information
            </Text>
          </Col>
        </Row>
      </div>

      {/* Patient Information Banner */}
      {patient && (
        <Card 
          style={{ 
            marginBottom: '24px', 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            color: 'white'
          }}
        >
          <Row align="middle" justify="space-between">
            <Col>
              <Title level={4} style={{ color: 'white', margin: 0 }}>
                {patient.lastName}, {patient.firstName} {patient.middleName || ''}
              </Title>
              <Text style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '14px' }}>
                Complete medical history and health records
              </Text>
            </Col>
            <Col>
              <div style={{ 
                background: 'rgba(255, 255, 255, 0.2)', 
                padding: '8px 16px', 
                borderRadius: '20px',
                backdropFilter: 'blur(10px)'
              }}>
                <Text style={{ color: 'white', fontWeight: 'bold' }}>
                  📊 Health Records
                </Text>
              </div>
            </Col>
          </Row>
        </Card>
      )}

      {/* Introduction Card */}
      <Card 
        style={{ 
          marginBottom: '24px', 
          background: '#fdfdfd', 
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '1px solid #e8f4fd'
        }}
      >
        <Row gutter={[24, 16]} align="middle">
          <Col xs={24} md={18}>
            <Title level={4} style={{ color: '#34495e', marginBottom: '8px' }}>
              📚 Your Complete Health Story
            </Title>
            <Text style={{ fontSize: '15px', color: '#5a6c7d', lineHeight: '1.6' }}>
              This section provides a comprehensive view of your medical history, including past conditions, 
              surgeries, current health problems, allergies, and family health history. All information is 
              presented in an easy-to-understand format to help you stay informed about your health.
            </Text>
          </Col>
          <Col xs={24} md={6} style={{ textAlign: 'center' }}>
            <div style={{
              background: 'linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)',
              borderRadius: '50%',
              width: '80px',
              height: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              boxShadow: '0 4px 15px rgba(116, 185, 255, 0.4)'
            }}>
              <HistoryOutlined style={{ fontSize: '32px', color: 'white' }} />
            </div>
          </Col>
        </Row>
      </Card>

      {/* Medical History Content */}
      <PatientPortalMedicalHistory />

      {/* Footer Information */}
      <Card 
        style={{ 
          marginTop: '24px', 
          background: '#f8f9fa', 
          border: '1px solid #e9ecef',
          textAlign: 'center'
        }}
      >
        <Text type="secondary" style={{ fontSize: '13px' }}>
          💡 <strong>Important:</strong> This information is for your reference only. 
          Always consult with your healthcare provider for medical advice and treatment decisions.
        </Text>
      </Card>
    </div>
  );
};

export default PatientPortalMedicalHistoryPage;
